<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 md11 lg11 xl11>
        <v-layout wrap justify-center py-4 v-if="storage.deliveryAddress">
          <v-flex xs12 text-left>
            <span
              style="
                font-family: poppinsmedium;
                font-size: 15px;
                color: #000000;
              "
            >
              ADDRESS
            </span>
          </v-flex>
          <v-flex xs12 text-left pt-2>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 14px;
                color: #000000;
              "
            >
              {{ storage.deliveryAddress.firstname }}
              {{ storage.deliveryAddress.lastname }}
            </span>
          </v-flex>
          <v-flex xs12 text-left pt-2>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              {{ storage.deliveryAddress.streetAddress }},
              {{ storage.deliveryAddress.locality }},
              {{ storage.deliveryAddress.city }},
              {{ storage.deliveryAddress.district }},
              {{ storage.deliveryAddress.state }},
              {{ storage.deliveryAddress.country }},
              {{ storage.deliveryAddress.pincode }}
            </span>
          </v-flex>
          <v-flex xs12 text-left pt-2>
            <v-layout wrap justify-center py-2>
              <v-flex xs1 align-self-center>
                <v-img
                  src="./../../../assets/icons/phone.svg"
                  height="15px"
                  contain
                ></v-img>
              </v-flex>
              <v-flex xs11 align-self-center>
                <span
                  v-if="storage.deliveryAddress.delphone"
                  style="
                    font-family: opensanssemibold;
                    font-size: 14px;
                    color: #474747;
                  "
                >
                  {{ storage.deliveryAddress.delphone }}
                </span>
                <span v-else>-</span>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-center py-2>
              <v-flex xs1 align-self-center>
                <v-img
                  src="./../../../assets/icons/email.svg"
                  height="15px"
                  contain
                ></v-img>
              </v-flex>
              <v-flex xs11 align-self-center>
                <span
                  v-if="storage.deliveryAddress.email"
                  style="
                    font-family: opensanssemibold;
                    font-size: 14px;
                    color: #474747;
                  "
                >
                  {{ storage.deliveryAddress.email }}
                </span>
                <span v-else>-</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout
          wrap
          justify-center
          py-4
          v-if="storage.shippedService || storage.trackingId"
        >
          <v-flex xs12 text-left>
            <span
              style="
                font-family: poppinsmedium;
                font-size: 15px;
                color: #000000;
              "
            >
              SHIPMENT DETAILS
            </span>
          </v-flex>
          <v-flex xs12 text-left pt-2 v-if="storage.shippedService">
            <span
              style="font-family: poppinslight; font-size: 14px; color: #8d8d8d"
            >
              Service:
            </span>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 14px;
                color: #000000;
              "
            >
              {{ storage.shippedService }}
            </span>
          </v-flex>
          <v-flex xs12 text-left pt-1 v-if="storage.trackingId">
            <span
              style="font-family: poppinslight; font-size: 14px; color: #8d8d8d"
            >
              Tracking ID:
            </span>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 14px;
                color: #000000;
              "
            >
              {{ storage.trackingId }}
            </span>
          </v-flex>
          <v-flex xs12 pt-4>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex xs6 text-left>
            <span
              style="
                font-family: poppinsmedium;
                font-size: 15px;
                color: #000000;
              "
            >
              PRICE DETAILS
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="font-family: poppinslight; font-size: 12px; color: #000000"
              v-if="items"
            >
              {{ items.length }} item<span
                v-if="items.length > 1"
                >s
              </span>
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center pt-4>
          <v-flex xs6 text-left>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Total MRP
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Rs.
              <span v-if="storage.actualOrderTotal">
                {{ storage.actualOrderTotal }}
              </span>
              <span v-else>0</span>
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Discount Amount
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #2cb194"
            >
              - Rs.
              <span v-if="storage.priceDifference">
                {{ storage.priceDifference.toFixed(2) }}
              </span>
              <span v-else>0</span>
            </span>
          </v-flex>
        </v-layout>
        
        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span style="font-family: poppinslight; font-size: 14px; color: #000000">Taxable Amount</span>
          </v-flex>
          <v-flex xs6 text-right>
            <span style="font-family: poppinslight; font-size: 14px; color: #000000">
              Rs. {{ Number(storage.taxableAmount || 0).toFixed(2) }}
            </span>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span style="font-family: poppinslight; font-size: 14px; color: #000000">GST</span>
          </v-flex>
          <v-flex xs6 text-right>
            <span style="font-family: poppinslight; font-size: 14px; color: #000000">
              Rs. {{ Number(storage.taxAmount || 0).toFixed(2) }}
            </span>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-center pt-1>
          <v-flex xs6 text-left>
            <span style="font-family: poppinslight; font-size: 13px; color: #8d8d8d; padding-left: 20px;">SGST</span>
          </v-flex>
          <v-flex xs6 text-right>
            <span style="font-family: poppinslight; font-size: 13px; color: #8d8d8d">
              Rs. {{ Number((storage.taxAmount || 0) / 2).toFixed(2) }}
            </span>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-center pt-1>
          <v-flex xs6 text-left>
            <span style="font-family: poppinslight; font-size: 13px; color: #8d8d8d; padding-left: 20px;">CGST</span>
          </v-flex>
          <v-flex xs6 text-right>
            <span style="font-family: poppinslight; font-size: 13px; color: #8d8d8d">
              Rs. {{ Number((storage.taxAmount || 0) / 2).toFixed(2) }}
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Packing Charge
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Rs.
              <span v-if="storage.packingCharge">
                {{ storage.packingCharge }}
              </span>
              <span v-else>0</span>
            </span>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Delivery Charge
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Rs.
              <span v-if="storage.deliveryCharge">
                {{ storage.deliveryCharge }}
              </span>
              <span v-else>0</span>
            </span>
          </v-flex>
        </v-layout>
<!-- 
        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000"
            >
              Mode of Delivery
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="font-family: poppinslight; font-size: 14px; color: #000000; text-transform: capitalize;"
            >
      <span
        v-if="
          items &&
          items.length &&
          items[0].productId &&
          items[0].productId.modeOfDelivery
        "
      >
        {{ items[0].productId.modeOfDelivery }}
      </span>
              <span v-else>-</span>
            </span>
          </v-flex>
        </v-layout> -->

        <v-layout wrap justify-center py-4>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-center pt-2>
          <v-flex xs6 text-left>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 14px;
                color: #000000;
              "
            >
              TOTAL AMOUNT
            </span>
          </v-flex>
          <v-flex xs6 text-right>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 14px;
                color: #000000;
              "
            >
              RS.
              <span v-if="storage.orderTotal">
                {{ storage.orderTotal }}
              </span>
              <span v-else>0</span>
            </span>
          </v-flex>
        </v-layout>
        <!-- <v-layout wrap justify-center py-4>
          <v-flex xs12>
            <v-btn :ripple="false" depressed block tile color="#FF2323">
              <span
                style="
                  font-family: poppinssemibold;
                  font-size: 12px;
                  color: #fff;
                  text-transform: none;
                "
              >
                <span> Continue </span>
              </span>
            </v-btn>
          </v-flex>
        </v-layout> -->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["storage", "items"],
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      deliverydate: new Date(),
      user: {
        deliveryaddress: [],
      },
      cart: {},
    };
  },
  methods: {},
};
</script>
